import Lang from 'assets/Lang';
import zone from 'moment-timezone';
import Configs from 'utils/Configs';

const moment = require('moment');
// require('moment/locale/vi');
// moment.locale('vi');

export default {
  toDateGMT7(time) {
    return zone(time)
      .tz('Asia/Bangkok')
      .toDate();
  },

  gmt7ToLocalDate(time) {
    return zone.tz(time, 'Asia/Bangkok').toDate();
  },

  format: (str, formatStr = 'YYYY-MM-DD HH:mm:ss') => {
    var time = moment(str || new Date()).format(formatStr);
    return time;
  },

  formatDefault: (str) => {
    var time = moment(str || new Date()).format(Configs.timeFormat);
    return time;
  },

  fromNow: (str, formatStr = '') => {
    return moment(str, formatStr).fromNow();
  },

  toDate: (str, formatStr = 'YYYY-MM-DD') => {
    var time = moment(str, formatStr).toDate();
    return new Date(time);
  },

  toMillisecond: (str) => {
    return moment(str).valueOf();
  },

  toObject: (time) => {
    if (!time) time = Date.now();
    let timeObject = new Date(time);
    let month = timeObject.getMonth() + 1;
    if (month < 10) month = '0' + month;
    let date = timeObject.getDate();
    if (date < 10) date = '0' + date;
    return {
      date,
      month,
      year: timeObject.getFullYear()
    };
  },

  subDay: (date1, date2, unit = 'days') => {
    var a = moment(date1);
    var b = moment(date2);
    return a.diff(b, unit);
  },

  subtract: (date, amount, unit = 'day', format = 'YYYY-MM-DD'): string => {
    var a = moment(date, format);
    a = a.subtract(amount, unit);
    return a.format(format);
  },

  nextBirthday: (timeObj: { date: number, month: number | string, year: number }) => {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month > parseInt(timeObj.month) || (day > timeObj.date && month === parseInt(timeObj.month))) year += 1;
    return {
      year,
      month: timeObj.month,
      date: timeObj.date
    };
  },

  convertTimeToHour(timeSecond, showSecond = true) {
    var timeShort = '00:00:00';
    let timeFull = `${0} ${Lang.hour}`;
    if (timeSecond < 0) return { timeShort, timeFull };
    try {
      var second = timeSecond % 60;
      var hour = Math.floor(timeSecond / 3600);
      const hourRedu = timeSecond / 3600 - hour;
      var min = Math.floor(Math.round(hourRedu * 3600) / 60);
      if (second < 60) {
        second = parseInt(second);
      }
      if (second < 10) {
        second = '0' + parseInt(second);
      }
      if (min < 10) {
        min = '0' + min;
      }
      if (hour < 10) {
        hour = '0' + parseInt(hour);
      }
      timeShort = hour + ':' + min + ':' + second;
      timeFull = `${hour} ${Lang.hour} ${min} ${Lang.minutes} ${second} ${Lang.second}`;
      if (!showSecond) {
        timeShort = hour + ':' + min;
        timeFull = `${hour} ${Lang.hour} ${min} ${Lang.minutes}`;
      }
    } catch (err) {
      console.log('ERROR', err);
    }
    return { timeShort, timeFull };
  }
};
